


























































import { Component, Prop, Provide, Vue } from "vue-property-decorator";
import BannerTmp from "./../../common/banner/bannerTop.vue";
import EffectTmp from "./../../common/effect_footer/effect_footer.vue";

@Component({
    components:{
        BannerTmp,
        EffectTmp
    }
})
export default class monitorfloodIndex extends Vue {
    //向子组件传值
    //protected 修饰的属性或者方法是私有的，但它的子组件可以访问到
    protected bannerData: object = {
        imgUrl: require('../../../../static/images/banner_monitor.png'),
        title: '智慧水务防汛监控',
        subTitle: '轻松助力业务降本增效'
    };
    public list: any= [
        {imgUrl: require('../../../assets/images/solution/flood/flood_1.png'), title: '投入高', des: '汛期需24小时关注摄像头状态，人力资源投入大。'},
        {imgUrl: require('../../../assets/images/solution/flood/flood_2.png'), title: '人工效率低', des: '人工质巡检效率低，时间长，及时性不高。'},
        {imgUrl: require('../../../assets/images/solution/flood/flood_3.png'), title: '容错率低', des: '汛期监控如果出现疏漏，可能会导致较严重的后果。'}
    ];

    public frontArr: any= [
        {imgUrl: require('../../../assets/images/solution/flood/flood_6.svg'), number: 1, text: '登录防汛视频监控平台'},
        {imgUrl: require('../../../assets/images/solution/flood/flood_7.svg'), number: 2, text: '展开监控资源树'},
        {imgUrl: require('../../../assets/images/solution/flood/flood_8.svg'), number: 3, text: '查看设备状态'},
        {imgUrl: require('../../../assets/images/solution/flood/flood_9.svg'), number: 4, text: '发现异常设备'},
        {imgUrl: require('../../../assets/images/solution/flood/flood_10.svg'), number: 5, text: '手动保存'},
        {imgUrl: require('../../../assets/images/solution/flood/flood_11.svg'), number: 6, text: '发送告警邮件'},
        {imgUrl: require('../../../assets/images/solution/flood/flood_12.svg'), number: 7, text: '查看告警并抢修'}
    ];
    public afterArr: any= [
        {imgUrl: require('../../../assets/images/solution/flood/flood_13.svg'), number: 1, text: '登录防汛视频监控平台'},
        {imgUrl: require('../../../assets/images/solution/flood/flood_14.svg'), number: 2, text: '展开监控资源树'},
        {imgUrl: require('../../../assets/images/solution/flood/flood_15.svg'), number: 3, text: '扫描异常设备'},
        {imgUrl: require('../../../assets/images/solution/flood/flood_16.svg'), number: 4, text: '保存汇总'},
        {imgUrl: require('../../../assets/images/solution/flood/flood_17.svg'), number: 5, text: '发送告警邮件'},
        {imgUrl: require('../../../assets/images/solution/flood/flood_18.svg'), number: 6, text: '查看告警并抢修'}
    ];

}

